export enum IdType {	
	Passport = 0,
	IdCard = 10,
	DrivingLicense = 20,
	BirthCertificate = 30,
}